/**
 *
 * RoomPickerFilter
 *
 */
import * as React from 'react';
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import { Entity } from 'types/common';
import { IFilterComponentProps } from '../IFilterComponentProps';
import { LocationPicker } from 'app/components/pickers/AutocompletePickers/LocationPicker';

export const LocationPickerFilter = (props: IFilterComponentProps) => {
  const handleOnChange = (value: Entity<number> | null) => {
    props.onChange(value);
  };
  const { t } = useTranslation();
  return (
    <LocationPicker
      onChange={handleOnChange}
      value={props.value}
      isOpen={props.open}
      placeholder={t(translations.AllValues)}
      size="small"
      ariaLabel={props.label}
      id={props.id}
    />
  );
};
export default LocationPickerFilter;
